import React from 'react';
import { useSelector } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import classnames from 'classnames';
import { tourLabelsSelector } from '../../../../../store/selectors/tour';
import { FlightsLabelItem } from './FlightsLabelItem';
import styles from './FlightsLabelList.module.css';

export interface FlightsLabelListProps {
  tourId: string;
}

export const FlightsLabelList: React.FC<FlightsLabelListProps> = ({
  tourId,
}) => {
  const isMobile = useSelector(getIsMobile);
  const labels = useSelector((state) => tourLabelsSelector(state, tourId));

  if (!labels || labels.length === 0) return null;

  return (
    <div
      className={classnames(styles.list, {
        [styles.listMobile]: isMobile,
      })}
    >
      {labels.map((label) => (
        <FlightsLabelItem key={label.id} label={label} isMobile={isMobile} />
      ))}
    </div>
  );
};
